var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcWifiDisconnectedWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "01 Icons/01 Small/ic-wifi-disconected") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01-Icons/01-Small/ic-wifi-disconected",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wifi-solid",
    transform: "translate(0.000000, 2.000000)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#ffffff",
    transform: "translate(11.000000, 10.000000) scale(-1, 1) rotate(45.000000) translate(-11.000000, -10.000000) ",
    points: "9.625 -2.375 12.375 -2.375 12.375 22.375 9.625 22.375"
  })), /*#__PURE__*/React.createElement("g", {
    id: "wifi-solid",
    opacity: 0.5,
    transform: "translate(1.000000, 4.000000)",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.825015,4.38857146 C15.7347926,-1.46392853 6.26275573,-1.46178567 0.174939595,4.38857146 C-0.0539980414,4.60857145 -0.058466794,4.98107145 0.162908338,5.20928574 L1.33990904,6.42250002 C1.55097167,6.64035716 1.89059687,6.64500002 2.1099095,6.43607145 C7.12591249,1.66178575 14.8733546,1.66071432 19.8903889,6.43607145 C20.1097015,6.64500002 20.4493267,6.64000002 20.6603893,6.42250002 L21.83739,5.20928574 C22.0584214,4.98107145 22.0539526,4.60857145 21.825015,4.38857146 Z M10.9999773,11.4285714 C9.78482033,11.4285714 8.79997599,12.4517857 8.79997599,13.7142857 C8.79997599,14.9767857 9.78482033,16 10.9999773,16 C12.2151343,16 13.1999786,14.9767857 13.1999786,13.7142857 C13.1999786,12.4517857 12.2151343,11.4285714 10.9999773,11.4285714 Z M17.9667627,8.4432143 C14.0046978,4.80285717 7.99078801,4.80678574 4.0331919,8.4432143 C3.79600425,8.66107145 3.78844175,9.03928573 4.01359813,9.27000002 L5.19747384,10.4839286 C5.40372396,10.6953572 5.73578666,10.7096429 5.95544304,10.5125 C8.84122601,7.9207143 13.1652598,7.92642859 16.0441678,10.5125 C16.2638242,10.7096429 16.5958869,10.6957143 16.802137,10.4839286 L17.9860127,9.27000002 C18.2115128,9.03928573 18.2036066,8.6607143 17.9667627,8.4432143 L17.9667627,8.4432143 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWifiDisconnectedWhite);
export default __webpack_public_path__ + "static/media/ic-wifi-disconnected-white.df28a0fac3c309ba86483de8f71355df.svg";
export { ForwardRef as ReactComponent };